import { gql } from '../../__generated__';
import gqlTag from 'graphql-tag';
import { UserItem } from '../../interfaces.graphql';

export const OrderItem = gql(`
  fragment OrderItem on OrderQueryModel {
    id
    orderNumber
    invoiceNumber
    creditInvoiceNumber
    description
    amount
    paymentMode
    registrationEmail
    user {
      ...UserItem
    }
    license {
      id
      companyName
    }
    type
    status
    startedAt
    invoiceContentId
    creditInvoiceContentId
    errorMessage
    isInvoiceable
  }
`);



export const RETRY_PURCHASE = gql(`
  mutation RetryPurchase($input: RetryPurchaseInput!) {
    retryPurchase(input: $input) {
      ...OrderItem
    }
  }
`);

export const GET_ORDERS = gql(`
  query GetOrders($showIncomplete: Boolean!, $page: Int!, $pageSize: Int!, $licenseId: Int, $searchTerm: String) {
    orders: allOrders(showIncomplete: $showIncomplete, page: $page, pageSize: $pageSize, licenseId: $licenseId, searchTerm: $searchTerm) {
      orders {
        ...OrderItem
      }
      count
    }
  }
`);

export const GET_COMPLETED_ORDERS_WITH_DISCOUNT = gqlTag(`
  query GetCompletedOrdersWithDiscount($id: ID!, $daysBack: Int!, $monthsBack: Int!) {
    orderCounts: completedOrdersWithDiscount(discountId: $id, daysBack: $daysBack, monthsBack: $monthsBack) {
      siste30Dager {
        count
      }
      siste12Maaneder {
        count
      }
      totalt {
        count
      }
    }
  }
`);

export const CANCEL_ORDER = gql(`
  mutation CancelOrder($input: CancelOrderInput!) {
    cancelOrder(input: $input) {
      ...OrderItem
    }
  }
`);

export const CREDIT_ORDER = gql(`
  mutation CreditOrder($input: CreditOrderInput!) {
    creditOrder(input: $input) {
      ...OrderItem
    }
  }
`);

export const UPDATE_ORDER = gql(`
  mutation UpdateOrder($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      ...OrderItem
    }
  }
`);
